/**
 * Format a text to return a first-character uppercase, and lowercase remainder
 * @function capitalize
 * @since v1.0.0
 * @param {string} text string to format
 * @returns {string} new string will a capitalized first letter and lower case remainder
 */
export const capitalize = (text: string): string =>
	text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
